import { FormattedMessage } from 'react-intl';
import { type Country } from 'react-phone-number-input';

import { cn } from '@/lib/cn';
import { Checkbox } from '@heidi/design-system/checkbox';
import { Label } from '@heidi/design-system/label';

import { personalizationSharedMessages } from '@heidi/growth';
import { RequestDemoPhoneAndReasonFields } from '../shared/RequestDemoPhoneAndReasonFields';

interface RequestDemoSectionProps {
  ctaOptIn: boolean;
  demoReason: string;
  phoneNumber: string;
  defaultCountry?: Country;
  /** Country name forwarded to the DEV-11979 reason_for_demo_phone field_selected event. */
  countryName?: string;
  /** Language code forwarded to the DEV-11979 reason_for_demo_phone field_selected event. */
  language?: string;
  onCtaOptInChange: (checked: boolean) => void;
  onDemoReasonChange: (value: string) => void;
  onPhoneNumberChange: (value: string) => void;
}

export function RequestDemoSection({
  ctaOptIn,
  demoReason,
  phoneNumber,
  defaultCountry,
  countryName,
  language,
  onCtaOptInChange,
  onDemoReasonChange,
  onPhoneNumberChange,
}: RequestDemoSectionProps) {
  return (
    <div className="flex w-full max-w-[400px] flex-col gap-3 rounded-xl border border-border bg-validation-info-muted p-4">
      <div className="flex items-center gap-2">
        <Checkbox
          id="demo-request"
          checked={ctaOptIn}
          onCheckedChange={(checked) => onCtaOptInChange(checked === true)}
        />
        <Label htmlFor="demo-request" className="text-text-primary">
          <FormattedMessage {...personalizationSharedMessages.requestDemoSignup} />
        </Label>
      </div>

      <div
        className={cn(
          'grid transition-[grid-template-rows,opacity] duration-300 ease-out',
          ctaOptIn ? 'grid-rows-[1fr] opacity-100' : 'grid-rows-[0fr] opacity-0'
        )}
        aria-hidden={!ctaOptIn}
      >
        <div className="overflow-hidden">
          <RequestDemoPhoneAndReasonFields
            phoneNumber={phoneNumber}
            onPhoneNumberChange={onPhoneNumberChange}
            defaultCountry={defaultCountry}
            demoReason={demoReason}
            onDemoReasonChange={onDemoReasonChange}
            disabled={!ctaOptIn}
            country={countryName}
            language={language}
          />
        </div>
      </div>
    </div>
  );
}
